import { useContext } from 'react'
import Context, { INavigationContext } from './NavigationContext'

const useDrawer = () => useContext<INavigationContext>(Context)

export default useDrawer
